export default "__VITE_ASSET__DUHIfxWo__"